<template>
  <section class="searchMember">
    <label for="type">Business Type</label>
    <div class="select" >
      <select id="type" v-model="model.companyTypeId">
        <option value="">{{ $t('manageMember.select') }}</option>
        <option
          v-for="item in companyData" :key="item.id"
          :value="item.id">{{ item.name }}</option>
      </select>
    </div>
    <label for="company">Company</label><input type="text" name="company" id="company" title="company" maxlength="20"
        v-model="model.companyName" />
    <label for="id">ID</label><input type="text" name="id" id="id" title="id" maxlength="60"
      v-model="model.email" />
    <button type="button" class="btn_2" @click="onSearchClick">SEARCH</button>
  </section>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'UserSearchForm',
  props: ['menuName', 'companyData'],
  data () {
    return {
      model: {
        companyTypeId: '',
        companyName: null,
        email: null
      }
    }
  },
  created () {
  },
  methods: {
    onSearchClick () {
      const hasValidQuery = _.compact(_.values(this.model)).length
      let query = null

      if (hasValidQuery) {
        query = Object.assign({}, this.model)
      }

      this.$emit('onSearchClick', query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/UserSearchForm.vue